<template>
  <div class="goods-group-preview">
    <div v-if="groups.length" class="group-tabs">
      <button
        v-for="group in groups"
        :key="group.group_id"
        type="button"
        class="group-tab"
        :class="{ active: String(group.group_id) === String(activeGroupId) }"
        @click="activeGroupId = group.group_id"
      >{{ group.group_name }}</button>
    </div>
    <div v-else class="group-title">请选择商品分组</div>
    <goods-preview :preview="previewData"/>
  </div>
</template>

<script>
import GoodsPreview from '../Goods/GoodsPreview'

export default {
  name: 'GoodsGroupPreview',
  components: { GoodsPreview },
  data() { return { activeGroupId: '' } },
  computed: {
    groups() {
      if (Array.isArray(this.$$FormData.groups) && this.$$FormData.groups.length) return this.$$FormData.groups
      if (!this.$$FormData.group_id) return []
      return [{ group_id: this.$$FormData.group_id, group_name: this.$$FormData.group_name, goodsList: this.$$FormData.goodsList || [] }]
    },
    activeGroup() {
      return this.groups.find(group => String(group.group_id) === String(this.activeGroupId)) || this.groups[0]
    },
    previewData() {
      return {
        data: Object.assign({}, this.$$FormData, {
          list_style: this.activeGroup && this.activeGroup.list_style
            ? this.activeGroup.list_style
            : this.$$FormData.list_style,
          goodsList: this.activeGroup ? this.activeGroup.goodsList : []
        })
      }
    }
  },
  watch: {
    groups: {
      immediate: true,
      handler(groups) {
        if (!groups.length) this.activeGroupId = ''
        else if (!groups.some(group => String(group.group_id) === String(this.activeGroupId))) this.activeGroupId = groups[0].group_id
      }
    }
  }
}
</script>

<style scoped>
.goods-group-preview { padding-top: 6px; background: #f7f7f7; }
.group-title { padding: 9px 15px; color: #333; font-size: 15px; font-weight: 600; background: #fff; }
.group-tabs { display: flex; width: 100%; background: #fff; border-bottom: 1px solid #eee; }
.group-tab { flex: 1; min-width: 0; padding: 11px 4px 9px; overflow: hidden; border: 0; border-bottom: 2px solid transparent; color: #666; font-size: 13px; text-align: center; text-overflow: ellipsis; white-space: nowrap; background: transparent; cursor: pointer; }
.group-tab.active { border-bottom-color: #333; color: #222; font-weight: 600; }
</style>
